jQuery(function () {
    var errorClass = 'text-danger';
    var requiredText = 'Fältet är obligatoriskt.';
    var requiredDate = 'Du måste ange planteringsdatum';
    var minNumberText = 'Du måste välja en växt.';
    $(document).ready(function () {
        $('#edit-plant-type-form, #add-plant-type-form, #edit-garden-spot-form, #add-garden-spot-form').validate({
            errorClass: errorClass,
            rules: {
                'Name': {
                    required: true
                }
            },
            messages: {
                'Name': {
                    required: requiredText
                }
            }
        });
        $('#add-plant-and-plant-type-form').validate({
            errorClass: errorClass,
            rules: {
                'Name': {
                    required: true
                },
                'SeedingDate': {
                    required: true
                }
            },
            messages: {
                'Name': {
                    required: requiredText
                },
                'SeedingDate': {
                    required: requiredDate
                }
            }
        });
        $('#add-plant-form').validate({
            errorClass: errorClass,
            rules: {
                'SeedingDate': {
                    required: true
                },
                'PlantTypeId': {
                    required: true
                }
            },
            messages: {
                'SeedingDate': {
                    required: requiredDate
                },
                'PlantTypeId': {
                    required: minNumberText
                }
            },
            errorPlacement: function (error, element) {
                if (element.attr('name') === 'PlantTypeId') {
                    error.insertAfter('.plant-selection-wrapper');
                }
                else {
                    error.insertAfter(element);
                }
            }
        });
    });
});
